import difference from "lodash/difference";
import keys from "lodash/keys";
import map from "lodash/map";
import uniq from "lodash/uniq";
const createGroupNodesMap = (nodeSource) => {
    const record = {};
    nodeSource === null || nodeSource === void 0 ? void 0 : nodeSource.forEach(item => {
        var _a;
        if (item.GroupId) {
            if (record[item.GroupId]) {
                (_a = record[item.GroupId]) === null || _a === void 0 ? void 0 : _a.push(item);
            }
            else {
                record[item.GroupId] = [item];
            }
        }
    });
    return record;
};
export const processDeleted = ({ documentGraphData, prevData, appliedUpdates }) => {
    const newSourceDataNodeIds = map(documentGraphData.NodesSource, "NodeId");
    const newSourceDataEdgeIds = map(documentGraphData.EdgesSource, "EdgeId");
    const newSourceDataGroupIds = map(documentGraphData.DataGroups, "Id");
    const deletedInitialNodeIds = difference(keys(prevData.NodesSource), newSourceDataNodeIds);
    const deletedAppliedUpdatesNodeIds = difference(keys(appliedUpdates.appliedUpdatesNodesSource), newSourceDataNodeIds);
    const deletedNodeIds = uniq([...deletedInitialNodeIds, ...deletedAppliedUpdatesNodeIds]);
    const deletedInitialEdgeIds = difference(keys(prevData.EdgesSource), newSourceDataEdgeIds);
    const deletedAppliedUpdatesEdgeIds = difference(keys(appliedUpdates.appliedUpdatesEdgesSource), newSourceDataEdgeIds);
    const deletedEdgeIds = uniq([...deletedInitialEdgeIds, ...deletedAppliedUpdatesEdgeIds]);
    const prevDataGroups = prevData.DataGroups || [];
    const nodesForGroup = createGroupNodesMap(documentGraphData.NodesSource);
    const deletedInitialGroupIds = difference(map(prevDataGroups, "Id"), newSourceDataGroupIds);
    const deletedGroupIds = uniq([...deletedInitialGroupIds]).filter(item => !nodesForGroup[item]);
    return {
        deletedNodeIds,
        deletedEdgeIds,
        deletedGroupIds
    };
};
